export default "__VITE_ASSET__BdBQY_lN__"